/**
 * 加密方法
 */
import md5 from "js-md5";
let Base64 = require("js-base64").Base64;



function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}

export default function reSetData(requestData, token) {
  // 1.时间戳
  let timestamp = new Date().getTime() + "";
  // 2. uuid
  let nonce = guid();
  // 3.token
  // 4.data base64
  let base64Data = "";
  if (requestData) {
    base64Data = Base64.encode(JSON.stringify(requestData));
  } else {
    let map = {};
    base64Data = Base64.encode(JSON.stringify(map));
  }

  let data = { data: base64Data };
  data.timestamp = timestamp;
  data.nonce = nonce;
  if (token) {
    data.token = token;
  }
  let s = "";
  Object.keys(data)
    .sort()
    .forEach(k => {
      if (data[k] && data[k].length > 0) {
        if (s.length > 0) {
          s += "&";
        }
        ``;
        s += k + "=" + data[k];
      }
    });
  let md5Data = md5(s).toLocaleUpperCase();
  data.sign = md5Data;
  return data;
}

